export type KnowledgeBaseItemType = 'article' | 'video'

export interface KnowledgeBaseItem {
    id: string
    type: KnowledgeBaseItemType
    title: string
    summary: string
    imageUrl: string
    content?: string
    link?: string
    youtubeVideoId?: string
}

export const knowledgeBaseItems: KnowledgeBaseItem[] = [
    {
        id: 'cukor-es-rak-kapcsolata',
        type: 'article',
        title: 'A cukor és a rák közötti kapcsolat megértése: a preklinikai és klinikai bizonyítékok áttekintése.',
        summary:
            'A tanulmány azt vizsgálja, hogy van-e meggyőző bizonyíték arra, hogy a túlzott cukorfogyasztás közvetlenül hozzájárulna a rák kialakulásához vagy előrehaladásához. A szerzők előzetes (preklinikai) és klinikai vizsgálatok eredményeit foglalják össze annak érdekében, hogy átlássák az összefüggést a „cukor ↔ rák" tengelyen.',
        imageUrl: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=800&q=80',
        link: 'https://pmc.ncbi.nlm.nih.gov/articles/PMC9775518/',
    },
    {
        id: 'dietas-uditok-veszelyei',
        type: 'article',
        title: 'Meghökkentő felfedezés: a diétás üdítők veszélyesebbek lehetnek az egyik legfontosabb szervre, mint a cukrosak',
        summary:
            'Egy új kutatás szerint mind a cukrozott, mind a mesterséges édesítőszerekkel készült üdítőitalok jelentősen növelhetik a májbetegségek kockázatát – közölte a Science Daily.',
        imageUrl: 'https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=800&q=80',
        link: 'https://www.portfolio.hu/gazdasag/20251019/meghokkento-felfedezes-a-dietas-uditok-veszelyesebbek-lehetnek-az-egyik-legfontosabb-szervre-mint-a-cukrosak-794244#',
    },
    {
        id: 'mesterseges-edesitoszerek-kognitiv-hanyatlas',
        type: 'article',
        title: 'Az alacsony- és nullakalóriás mesterséges édesítőszerek fogyasztásának összefüggése a kognitív hanyatlással.',
        summary:
            'Az alacsony- és nullakalóriás édesítőszerek (LNCS) fogyasztását korábban már összefüggésbe hozták kedvezőtlen egészségügyi hatásokkal. Ugyanakkor keveset tudunk arról, hogy ezek fogyasztása miként befolyásolja a kognitív működést. A jelen tanulmány célja az volt, hogy feltárja az összefüggést az LNCS-ek fogyasztása és a kognitív hanyatlás között.',
        imageUrl: 'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=800&q=80',
        link: 'https://www.neurology.org/doi/10.1212/WNL.0000000000214023',
    },
    {
        id: 'bebietelek-egeszsegessege',
        type: 'article',
        title: 'A bébiételeket gyártó cégeket felszólították, hogy tegyék egészségesebbé termékeiket – különben intézkedésekre számíthatnak.',
        summary:
            'Az elmúlt években jelentős növekedés tapasztalható a bébiételek és -italok piacán. A tasakos ételek már a piac több mint egyharmadát teszik ki, és emellett nőtt a gyümölcs- és zöldségalapú snackek – például szívószál formájú rágcsák, puffasztott falatok és ostyák – eladása is. „A cégek ezeket a termékeket egészségesnek próbálják beállítani, pedig valójában inkább hasonlítanak egy chipsre vagy édességre. A profitot az egészség elé helyezik" – mondja Dr. Alison Tedstone, a kormány korábbi vezető táplálkozási szakértője.',
        imageUrl: 'https://images.unsplash.com/photo-1575052814086-f385e2e2ad1b?w=800&q=80',
        link: 'https://www.bbc.com/news/articles/cvgpld8p9rqo',
    },
    {
        id: 'joga-kezdoknek',
        type: 'video',
        title: 'Jóga kezdőknek: 20 perces egész testes gyakorlat',
        summary:
            'Lágy bevezető jóga egy teljes 20 perces gyakorlattal, amelyet kifejezetten abszolút kezdőknek terveztünk. Nem kell hozzá felszerelés.',
        imageUrl: 'https://images.unsplash.com/photo-1575052814086-f385e2e2ad1b?w=800&q=80',
        youtubeVideoId: 'v7AYKMP6rOE',
    },
    {
        id: 'egeszseges-etel-elokeszites',
        type: 'video',
        title: 'Egészséges ételelőkészítés: egy hét kiegyensúlyozott étkezése',
        summary:
            'Tanuld meg, hogyan készíthetsz elő egy teljes heti tápanyagban gazdag, finom ételeket mindössze két óra alatt. Takarítsd meg az idődet és egyél egészségesebben.',
        imageUrl: 'https://images.unsplash.com/photo-1546069901-ba9599a7e63c?w=800&q=80',
        youtubeVideoId: 'dBnniua6-oM',
    },
    {
        id: 'legzestechnikak',
        type: 'video',
        title: 'Légzéstechnikák a stresszoldáshoz',
        summary:
            'Sajátíts el három hatékony légzésgyakorlatot, amelyek segítenek a stressz kezelésében, a fókusz javításában és a gyorsabb elalvásban.',
        imageUrl: 'https://images.unsplash.com/photo-1508672019048-805c876b67e2?w=800&q=80',
        youtubeVideoId: 'tEmt1Znux58',
    },
]
